var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEsp = function SvgEsp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE00",
    d: "M1.1 12c0 1.4.3 2.8.8 4h20.3c.5-1.2.8-2.6.8-4s-.3-2.8-.8-4H1.9c-.5 1.2-.8 2.6-.8 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE2910",
    d: "M22.1 16H1.9c1.6 4 5.5 6.9 10.1 6.9S20.5 20 22.1 16M1.9 8h20.3C20.5 4 16.6 1.1 12 1.1S3.5 4 1.9 8"
  })));
};
export default SvgEsp;